console.log('✅ checkout-page-shopping-cart.js loaded successfully!');

import { APP_CONFIG } from '../../js/config.js';
import { appState, setAppStateValueByKey } from '../../js/state.js';
import { getTextTranslationByKey, loadTextTranslations } from '../../js/translator.js';
import { saveToLocalStorage, loadFromLocalStorage } from '../../js/utils-local-storage.js';
import { registerEventListenerToAttach } from '../../js/to-attach-event-listener-registry.js';
import { buildComponentBreadcrumb } from '../bread-crumbs/bread-crumb.js';
import {
  isNodeEnvironment,
  myFetchJsonContentFromBuildData,
} from '../../js/utils-fetch-data-json.js';
import {
  convertStringAmountToCurrencyAndSignDirectionForLanguage,
  getCurrencyCultureSymbolOnLeftOrRight,
} from '../../js/utils-convert-currency.js';
import {
  convertNumberStringFromUKFormatToAnyLanguageFormatDouble,
  convertStringToDecimal,
  convertStringToInt,
} from '../../js/utils-convert-numbers.js';
import { buildComponentCatalogListingImageSlider } from '../catalog/catalog-listing-image-slider.js';

import { navigateTo } from '../../js/router-navigator.js';

import { fetchAllShoppingCartItems } from '../../services/data-services/shopping-cart-data-service.js';
import { ShoppingCartSharedMethods } from '../../js/utils-shopping-cart-shared-methods.js';

import { renderDebugTable } from '../../js/utils-debug.js';


//https://demos.themeselection.com/sneat-bootstrap-html-admin-template/html/front-pages/checkout-page.html


export async function buildComponentCheckoutShoppingCart() {
  console.log(`🔄 Building Component: CheckoutPage - lang: ${appState.SiteLanguageCookie}`);

  try {
    // so it ends up in its own "translation-service" chunk:
    const { loadMyTranslationsService } = await import(
      /* webpackChunkName: "my-translator-service" */
      /* webpackPrefetch: true */
      '../../services/my-translator-service.js'
    );

    // 1) Load translations in parallel (cached after first call)
    const { _tempTextTranslator, _tempLinksTranslator } = await loadMyTranslationsService(
      appState.SiteLanguageCookie
    );

    const {
      keyShoppingCart: lblShoppingCart,
      keyContinueShopping: lblContinueShopping,
    } = _tempTextTranslator;

    const {
      keyMyMessages: linkMyMessages,
      keyDashboard: linkDashboard,
      keyWishlist: linkWishlist,
      keySearch: linkSearch,
      keyCart: linkCart,
    } = _tempLinksTranslator;

    // const pageSkeletonHTML = await buildPageSkeleton();

    const actualContentHTML = await buildActualContent();

    // const actualbuildListingContentHTML = await buildActualListingContent(params, listingModeIsLive);

    // const htmlToRender = pageSkeletonHTML;

    const htmlToRender = actualContentHTML;

    const html = `
        <div class="MainContentContainer-Regular">

    <div class="myDefault-back-btn-div">
        <button type="button" id="btnContinueShopping" class="myDefault-back-btn"><img width="25" height="25" src="${APP_CONFIG.IMAGES_BASE_URL}imgs/icons/svg/back-arrow5.svg" class="default-icon-svg" /><b> ${lblContinueShopping}</b></button>
    </div>




    <div class="ShoppingCart-overall-wrapper">

              <div class="ShoppingCartRow">
                 <div class="shoppingCartTitle">  ${lblShoppingCart}</div>
    
              </div>

              ${htmlToRender}

               

     </div>

      
        
        
        </div>


        `;

    // const html = actualbuildListingContentHTML;

    //const html = ` shopping cart test `;

    console.log('✅ CheckoutPage built successfully.');

    // Register event listeners
    // registerEventListenerToAttach(attachEventListenersCatalogProducts);
    registerEventListenerToAttach(async () => attachMainEventListenersForThisComponent());

    return html;
  } catch (err) {
    console.error('❌ Error building CheckoutPage:', err);
    return '<div>Error loading CheckoutPage </div>';
  }
}

export async function buildPageSkeleton() {
  const subDetails = await buildProductSkeletonSectionSubDetails();

  const html = `
      
     <div class="ShoppingCartRow">


                <div class="basket">
                    <br />
                    <br />

                    ${subDetails}

                </div>

                 <div class="summaryArea">
                    <div class="summary" style="border:none;">
                        <div class="my-site-lazy-loading-card my-fake-image-height-200">
                            <div class="my-site-lazy-loading-card-movement"></div>
                        </div>
                    </div>
                </div>



      </div>
      <br />
<br />
<br />
<br />



    `;

  return html;
}
function buildProductSkeletonSectionSubDetails() {
  const cardHtml = `
        <div class="grid-blog-home-bottom-section-card my-fake-image-height-50">
            <div class="my-site-lazy-loading-card">
                <div class="my-site-lazy-loading-card-movement"></div>
            </div>
        </div>
        <br />
        `;

  let html = '';

  for (let i = 0; i < 9; i++) {
    html += cardHtml;
  }

  return html;
}

export async function buildActualContent() {
  const cartAPIResult = await fetchAllShoppingCartItems();

  //const ok = await onFirstLoadOfShoppingCartUpdateSelectedShippingMethodIDWithFirstValidOneIfZeroReloadNotRequired(
  //    cartAPIResult?.listOfAllCanBuyNowOnlyShoppingCartItems,
  //    cartAPIResult?.listOfAllShoppingCartShippingMethodsAndPrices,
  //    cartAPIResult?.listOfAllShoppingCartSelectedShippingMethods
  //);
  //if (!ok) {
  //    // reload or re-render...

  //}

  const cartItems = cartAPIResult?.shoppingCartItems || null;
  //allShoppingCartShippingMethodsAndPrices
  //allShoppingCartSelectedShippingMethods
  //allShoppingCartTaxAndPaymentTotals

  // alert("cartItems: " + cartItems);
  // alert("cartItems length: " + cartItems?.length);

  // const summaryAreaHTML = cartItems === null || cartItems.lenght < 1 ? "" : renderSummaryArea();
  const summaryAreaHTML = cartItems?.length > 0 ? await renderSummaryArea(cartAPIResult) : '';

  const cartRowsHTML =
    cartItems?.length > 0 ? await renderCartRows(cartAPIResult) : renderEmptyCart();

  const cartBottomSummaryHTML =
    cartItems?.length > 0 ? await renderCartBottomSummarySection(cartAPIResult) : '';

  // const debugHTML = renderDebugTable(cartAPIResult?.allShoppingCartShippingMethodsAndPrices);

  //    const debugHTML = `
  //  <div style="    background: orange;    padding: 1em;    max-height: 50vh;    overflow: auto;  ">

  //    ${JSON.stringify(cartAPIResult?.allShoppingCartShippingMethodsAndPrices ?? [],null,2 )}
  //  </div>
  //`;

  // const cartTotals = await fetchCartTotals();

  const html = `
      
               <div class="ShoppingCartRow">


                    <div class="basket">
                    ${cartRowsHTML}
                     ${cartBottomSummaryHTML}
                    </div>
                    <div class="summaryArea">
                    ${summaryAreaHTML}

                 
                    </div>

               </div>


               <br />
<br />
<br />
<br />






        `;

  return html;
}

export async function renderCartRows(allShoppingCartData) {
  // pull out your arrays (default to empty arrays so .length is always safe)
  const cartItems = allShoppingCartData?.shoppingCartItems ?? [];
  const listOfAllShoppingCartShippingMethodsAndPrices =
    allShoppingCartData?.allShoppingCartShippingMethodsAndPrices ?? [];
  const listOfAllShoppingCartSelectedShippingMethods =
    allShoppingCartData?.allShoppingCartSelectedShippingMethods ?? [];
  const listOfAllShoppingCartTaxAndPaymentTotals =
    allShoppingCartData?.allShoppingCartTaxAndPaymentTotals ?? [];

  // if no items, render the empty-cart state
  if (cartItems.length === 0) {
    return renderEmptyCart();
  }

  // build each row in parallel
  let rowCount = 0;
  const itemsHtmlArray = await Promise.all(
    cartItems.map(async (row, index) => {
      // keep your rowCount name—but derive it from the index to avoid race conditions
      //  rowCount = index + 1;

      // synchronous total column
      const productRowTotalColwnHTML = renderProductRowTotalColumnHTML(
        row,
        listOfAllShoppingCartShippingMethodsAndPrices,
        listOfAllShoppingCartSelectedShippingMethods,
        listOfAllShoppingCartTaxAndPaymentTotals
      );

      // asynchronous SKU details
      const skuDetailsColumnWithImage = await renderSkuDetailsColumnWithImageHTML(
        row,
        listOfAllShoppingCartShippingMethodsAndPrices,
        listOfAllShoppingCartSelectedShippingMethods,
        listOfAllShoppingCartTaxAndPaymentTotals
      );

      // even/odd stripe
      const evenClass = index % 2 === 1 ? 'evenRowsOnly' : '';

      return `
        <div class="cartRow ${evenClass}">
          <div class="BasketIteminfoWrap">
            <div class="productDetailsSection">
              ${skuDetailsColumnWithImage}
            </div>
            <div class="prodTotal">
              ${productRowTotalColwnHTML}
            </div>
          </div>
        </div>
      `;
    })
  );

  // join into one big HTML string
  const itemsHtml = itemsHtmlArray.join('');
  return itemsHtml;
}

function renderEmptyCart() {
  return `
    <div class="ShoppingCartRow">
      <div class="shoppingCartEmpty-div">
        <div class="shoppingCartEmpty-text">Your shopping cart is empty</div>
      </div>
    </div>
  `;
}

async function renderSummaryArea(allShoppingCartData) {
  // so it ends up in its own "translation-service" chunk:
  const { loadMyTranslationsService } = await import(
    /* webpackChunkName: "my-translator-service" */
    /* webpackPrefetch: true */
    '../../services/my-translator-service.js'
  );

  // 1) Load translations in parallel (cached after first call)
  const { _tempTextTranslator, _tempLinksTranslator } = await loadMyTranslationsService(
    appState.SiteLanguageCookie
  );

  //await initTempTextTranslator(appState.SiteLanguageCookie);
  //await initTempLinksTranslator(appState.SiteLanguageCookie);

  const {
    keyWeAccept: lblWeAccept,
    keySubtotal: lblSubtotal,
    keyItemsInYourCart: lblItemsInYourCart,
    keyItemInYourCart: lblItemInYourCart,
    keyEstimatedTotal: lblEstimatedTotal,
  } = _tempTextTranslator;

  const {
    keyMyMessages: linkMyMessages,
    keyDashboard: linkDashboard,
    keyWishlist: linkWishlist,
    keySearch: linkSearch,
    keyCart: linkCart,
  } = _tempLinksTranslator;

  // pull out your arrays (default to empty arrays so .length is always safe)
  const cartItems = allShoppingCartData?.shoppingCartItems ?? [];
  const listOfAllShoppingCartShippingMethodsAndPrices =
    allShoppingCartData?.allShoppingCartShippingMethodsAndPrices ?? [];
  const listOfAllShoppingCartSelectedShippingMethods =
    allShoppingCartData?.allShoppingCartSelectedShippingMethods ?? [];
  const listOfAllShoppingCartTaxAndPaymentTotals =
    allShoppingCartData?.allShoppingCartTaxAndPaymentTotals ?? [];

  // if no items, render the empty-cart state
  if (cartItems.length === 0) {
    return '';
  }

  // 1) compute all of your totals in one go
  const {
    cartSubTotalAmountX,
    cartSubTotalPlusDiscountAmountX,
    cartTotalShippingX,
    cartTotalDiscountX,
    cartTotalTaxX,
    cartTotalAmountX,
    cartTotalItemsCountX,
  } = ShoppingCartSharedMethods.computeCartTotals(
    cartItems,
    listOfAllShoppingCartShippingMethodsAndPrices,
    listOfAllShoppingCartSelectedShippingMethods,
    listOfAllShoppingCartTaxAndPaymentTotals
  );

  // format back to currency+sign
  const fmt = amt =>
    convertStringAmountToCurrencyAndSignDirectionForLanguage(
      amt.toString(),
      appState.SiteLanguageCookie,
      '$',
      '$',
      '1'
    );

  const cartSubTotalAmount = fmt(cartSubTotalAmountX);
  const cartSubTotalPlusDiscountAmount = fmt(cartSubTotalPlusDiscountAmountX);
  const cartTotalShipping = fmt(cartTotalShippingX);
  const cartTotalDiscount = fmt(cartTotalDiscountX);
  const cartTotalTax = fmt(cartTotalTaxX);
  const cartTotalAmount = fmt(cartTotalAmountX);
  const cartTotalItemsCount = cartTotalItemsCountX.toString();

  const checkoutDisabled = true;

  const html = `
    <div class="summary">
              <div class="summary-total-items">
               ${
                 cartTotalItemsCountX > 1
                   ? ` ${cartTotalItemsCount} ${lblItemsInYourCart}`
                   : `${cartTotalItemsCount} ${lblItemInYourCart}`
               }
              </div>
             <div class="summary-total">
                           <div class="total-title">
                               ${lblEstimatedTotal}
                           </div>
                           <div class="total-value" id="basket-total">
                           ${cartTotalAmount} 
                           </div>
               </div>
              <div class="summary-checkout">
                <button class="checkout-cta" ${
                  checkoutDisabled ? 'disabled' : ''
                }>Go to Secure Checkout</button>
              </div>        
    </div>

    <div style="padding:1rem;">
           <strong> ${lblWeAccept}</strong><br />

           <img style="height:30px;margin-right:0.1rem;margin-top:0.1rem;" width="44" height="30" src="${
             APP_CONFIG.IMAGES_BASE_URL
           }imgs/pay/sty1/svg/Visa.svg" />
           <img style="height:30px;margin-right:0.1rem;margin-top:0.1rem;" width="44" height="30" src="${
             APP_CONFIG.IMAGES_BASE_URL
           }imgs/pay/sty1/svg/Amex.svg" />
           <img style="height:30px;margin-right:0.1rem;margin-top:0.1rem;" width="44" height="30" src="${
             APP_CONFIG.IMAGES_BASE_URL
           }imgs/pay/sty1/svg/Mastercard.svg" />
           <img style="height:30px;margin-right:0.1rem;margin-top:0.1rem;" width="44" height="30" src="${
             APP_CONFIG.IMAGES_BASE_URL
           }imgs/pay/sty1/svg/UnionPay.svg" />
           <img style="height:30px;margin-right:0.1rem;margin-top:0.1rem;" width="44" height="30" src="${
             APP_CONFIG.IMAGES_BASE_URL
           }imgs/pay/sty1/svg/JCB.svg" />
           <img style="height:30px;margin-right:0.1rem;margin-top:0.1rem;" width="44" height="30" src="${
             APP_CONFIG.IMAGES_BASE_URL
           }imgs/pay/sty1/svg/PayPal.svg" />

    </div>


  `;

  return html;
}

async function renderSkuDetailsColumnWithImageHTML(
  row,
  listOfAllShoppingCartShippingMethodsAndPrices,
  listOfAllShoppingCartSelectedShippingMethods,
  listOfAllShoppingCartTaxAndPaymentTotals
) {
  // so it ends up in its own "translation-service" chunk:
  const { loadMyTranslationsService } = await import(
    /* webpackChunkName: "my-translator-service" */
    /* webpackPrefetch: true */
    '../../services/my-translator-service.js'
  );

  // 1) Load translations in parallel (cached after first call)
  const { _tempTextTranslator, _tempLinksTranslator } = await loadMyTranslationsService(
    appState.SiteLanguageCookie
  );

  //await initTempTextTranslator(appState.SiteLanguageCookie);
  //await initTempLinksTranslator(appState.SiteLanguageCookie);

  const {
    keySeller: lblSeller,
    keyProductCode: lblProductCode,
    keyInStock: lblInStock,
    KeyOutOfStock: lblOutOfStock,
  } = _tempTextTranslator;

  const {
    keyMyMessages: linkMyMessages,
    keyDashboard: linkDashboard,
    keyWishlist: linkWishlist,
    keySearch: linkSearch,
    keyCart: linkCart,
  } = _tempLinksTranslator;

  const skuReturnLinkPath = `/${appState.SiteLanguageCookie}/
        ${row.departmentID}/${row.departmentSEOPageName}/
        ${row.categoryID}/${row.categorySEOPageName}/
        ${row.productID}/${row.productSEOPageName}/
        ${row.listingID}/${row.skuid}/${row.listingSEOPageName}`.replace(/\s+/g, ''); // optional: strip your template whitespace

  const skuCode = `S${row.storeID}L${row.listingID}k${row.skuid}`;

  const skuDetailsQuanitityAndPriceSubSectionHTML = await renderSkuDetailsQuanitityAndPriceSubSectionHTML(
    row,
    listOfAllShoppingCartShippingMethodsAndPrices,
    listOfAllShoppingCartSelectedShippingMethods,
    listOfAllShoppingCartTaxAndPaymentTotals
  );

  const skuShippingAndDeliverySubSectionHTML = await renderSkuShippingAndDeliverySubSectionHTML(
    row,
    listOfAllShoppingCartShippingMethodsAndPrices,
    listOfAllShoppingCartSelectedShippingMethods,
    listOfAllShoppingCartTaxAndPaymentTotals
  );

  const html = `

    <div class="productDetailsSection-cart-items-grid">

            <div class="imageSection">


                        <a href="${skuReturnLinkPath}">   <img src="${row.image1FileName}" alt="${
    row.listingName
  }" />    </a>                               
                
                      <center>
                        <div class="divRemoveSKUFromCartWrapper">

                          <div id="divRemoveSKUFromCartParent${row.skuid}">
                            <button class="shoppingCartDeleteBtn"  data-sku="${row.skuid}">
                              Remove
                            </button>
                          </div>

                          <div id="divRemoveSKUFromCartChild${row.skuid}" style="display:none;">

                              
                              <br />

                            <button class="shoppingCart-DeleteSaveForLaterBtn"
                              data-action="save-for-later" data-sku="${row.skuid}">
                              Save for later
                            </button>

                            <button class="shoppingCartDeleteBtn-Confirm"
                              data-action="confirm-remove" data-sku="${row.skuid}">
                              Delete
                            </button>

                            <button class="shoppingCartDeleteBtn-Cancel" data-sku="${row.skuid}">
                              Cancel
                            </button>

                          </div>
                        </div>
                      </center>
                

            </div>

            <div class="productDetailsSection-ListingName">${row.listingName}</div>
            <div class="attributesDetails"> ${lblProductCode}: ${skuCode}${
    row.attributes ? ` - ${row.attributes}` : ''
  }</div>
            <div class="productDetailsSection-StoreName"> ${lblSeller} : ${row.storeName}</div>

           ${row.canBuyNow ? ` ${skuDetailsQuanitityAndPriceSubSectionHTML}` : ``}

          <div class="productDetailsSection-InStock">${row.inStock ? lblInStock : ''}</div>

          ${skuShippingAndDeliverySubSectionHTML}


     </div>


    `;

  return html;
}

async function renderSkuDetailsQuanitityAndPriceSubSectionHTML(
  row,
  listOfAllShoppingCartShippingMethodsAndPrices,
  listOfAllShoppingCartSelectedShippingMethods,
  listOfAllShoppingCartTaxAndPaymentTotals
) {
  // so it ends up in its own "translation-service" chunk:
  const { loadMyTranslationsService } = await import(
    /* webpackChunkName: "my-translator-service" */
    /* webpackPrefetch: true */
    '../../services/my-translator-service.js'
  );

  // 1) Load translations in parallel (cached after first call)
  const { _tempTextTranslator, _tempLinksTranslator } = await loadMyTranslationsService(
    appState.SiteLanguageCookie
  );

  //await initTempTextTranslator(appState.SiteLanguageCookie);
  //await initTempLinksTranslator(appState.SiteLanguageCookie);

  const {
    keyPrice: lblPrice,
    keyProductCode: lblProductCode,
    keyBuy: lblBuy,
    keyAndSave: lblAndSave,
  } = _tempTextTranslator;

  const {
    keyMyMessages: linkMyMessages,
    keyDashboard: linkDashboard,
    keyWishlist: linkWishlist,
    keySearch: linkSearch,
    keyCart: linkCart,
  } = _tempLinksTranslator;

  //const countrySalesTaxTotal = convertStringAmountToCurrencyAndSignDirectionForLanguage(
  //    ShoppingCartSharedMethods.getTotalCountryTaxCostPerSKUAndStoreIDAsDouble(
  //        row.skuid,
  //        row.storeID,
  //        listOfAllShoppingCartTaxAndPaymentTotals
  //    ).toString(),
  //    appState.SiteLanguageCookie,
  //    "$", "$", "1"
  //);

  const displaySKUPrice = convertStringAmountToCurrencyAndSignDirectionForLanguage(
    row.skuPrice,
    appState.SiteLanguageCookie,
    '$',
    '$',
    '1'
  );

  const displayUnitPriceWithDiscount = convertStringAmountToCurrencyAndSignDirectionForLanguage(
    row.skuUnitPriceByQty,
    appState.SiteLanguageCookie,
    '$',
    '$',
    '1'
  );

  const displayNextSKUDiscountTotal = convertStringAmountToCurrencyAndSignDirectionForLanguage(
    row.nextSKUDiscountTotal,
    appState.SiteLanguageCookie,
    '$',
    '$',
    '1'
  );

  const html = `

    <div class="shoppingcart-ProductPriceItemSubRow">
              <div class="PlusAndMinusDiv">
              <button class="qtyAddMinus" data-action="decrease" data-sku="${row.skuid}">-</button>
                   <input type="text" value="${row.skuQuantity}" class="textBoxQty" data-sku="${
    row.skuid
  }" />
                   <button class="qtyAddMinus" data-action="increase" data-sku="${
                     row.skuid
                   }">+</button>
                   <button class="btnUpdateSKUQty" style="display:none;"  data-action="update" data-sku="${
                     row.skuid
                   }">     Update row    </button>

              </div>

              <div class="shoppingcart-PriceAndXWrapper">
                  <div class="shoppingcart-XContent"> ${lblPrice}</div>

                  ${
                    displaySKUPrice !== displayUnitPriceWithDiscount
                      ? `<div class="shoppingcart-PriceContent">   ${displaySKUPrice}   </div>`
                      : ``
                  }
              
                    <div class="shoppingcart-PriceDiscountContent">        ${displayUnitPriceWithDiscount} / ${
    row.abvSingle
  }                </div>

                    

              </div>

              <div id="divShowPotentialSavings" class="shoppingcart-SavingsItemSubRow">
                    ${
                      row.nextSKUDiscountQty > 0
                        ? `${lblBuy} ${row.nextSKUDiscountQty} ${lblAndSave} ${displayNextSKUDiscountTotal}`
                        : ''
                    } 
              </div>


      </div>`;
  return html;
}

async function renderSkuShippingAndDeliverySubSectionHTML(
  row,
  listOfAllShoppingCartShippingMethodsAndPrices,
  listOfAllShoppingCartSelectedShippingMethods,
  listOfAllShoppingCartTaxAndPaymentTotals
) {
  // so it ends up in its own "translation-service" chunk:
  const { loadMyTranslationsService } = await import(
    /* webpackChunkName: "my-translator-service" */
    /* webpackPrefetch: true */
    '../../services/my-translator-service.js'
  );

  // 1) Load translations in parallel (cached after first call)
  const { _tempTextTranslator, _tempLinksTranslator } = await loadMyTranslationsService(
    appState.SiteLanguageCookie
  );

  //await initTempTextTranslator(appState.SiteLanguageCookie);
  //await initTempLinksTranslator(appState.SiteLanguageCookie);

  const {
    keyPrice: lblPrice,
    keyProductCode: lblProductCode,
    keyBuy: lblBuy,
    keyAndSave: lblAndSave,
  } = _tempTextTranslator;

  const {
    keyMyMessages: linkMyMessages,
    keyDashboard: linkDashboard,
    keyWishlist: linkWishlist,
    keySearch: linkSearch,
    keyCart: linkCart,
  } = _tempLinksTranslator;

  //const countrySalesTaxTotal = convertStringAmountToCurrencyAndSignDirectionForLanguage(
  //    ShoppingCartSharedMethods.getTotalCountryTaxCostPerSKUAndStoreIDAsDouble(
  //        row.skuid,
  //        row.storeID,
  //        listOfAllShoppingCartTaxAndPaymentTotals
  //    ).toString(),
  //    appState.SiteLanguageCookie,
  //    "$", "$", "1"
  //);

  const displaySKUPrice = convertStringAmountToCurrencyAndSignDirectionForLanguage(
    row.skuPrice,
    appState.SiteLanguageCookie,
    '$',
    '$',
    '1'
  );

  const displayUnitPriceWithDiscount = convertStringAmountToCurrencyAndSignDirectionForLanguage(
    row.skuUnitPriceByQty,
    appState.SiteLanguageCookie,
    '$',
    '$',
    '1'
  );

  const displayNextSKUDiscountTotal = convertStringAmountToCurrencyAndSignDirectionForLanguage(
    row.nextSKUDiscountTotal,
    appState.SiteLanguageCookie,
    '$',
    '$',
    '1'
  );

  const methodsForThisSku = listOfAllShoppingCartShippingMethodsAndPrices.filter(
    m => m.skuid === row.skuid
  );

  const theCurrentSKUSelectedShippingMethodID = ShoppingCartSharedMethods.getSKUCurrentSelectedShippingMethodFromViewState(
    row.skuid,
    listOfAllShoppingCartSelectedShippingMethods
  );

  const displayEstimatedDeliveryDate = ShoppingCartSharedMethods.getEstimatedDeliveryDatePerSKUTranslated(
    appState.SiteLanguageCookie,
    row.skuid,
    listOfAllShoppingCartShippingMethodsAndPrices,
    listOfAllShoppingCartSelectedShippingMethods
  );

  const skuHasValidTaxOptionForCart = ShoppingCartSharedMethods.skuHasValidTaxOptionForCart(
    row.skuid,
    listOfAllShoppingCartShippingMethodsAndPrices,
    listOfAllShoppingCartSelectedShippingMethods,
    listOfAllShoppingCartTaxAndPaymentTotals
  );

  const html = `

             <div class="productDetailsSection-ShippingMethod-wrapper">
                     <div class="productDetailsSection-ShippingMethod-Title">
                       Shipping Method ${
                         row.shippingMethodID
                       } curr/sel: ${theCurrentSKUSelectedShippingMethodID}
                     </div>

                     ${
                       methodsForThisSku.length > 0
                         ? `<select class="selectShippingTypeDropDown" data-sku="${row.skuid}">
                   ${methodsForThisSku
                     .map(
                       o =>
                         `  <option   value="${o.shippingMethodID}"   ${
                           o.shippingMethodID === row.selectedShipping ? 'selected' : ''
                         }>  ${o.shippingMethodName}     </option>`
                     )
                     .join('')}
                         </select>`
                         : `<div class="productDetailsSection-NoShippingMethod-Title">
                           No shipping option available
                         </div>`
                     }

                      <div class="productDetailsSection-ShippingDeliveryDate-Title">

                      ${displayEstimatedDeliveryDate}

                      </div>

                    
                       ${
                         !skuHasValidTaxOptionForCart
                           ? ` <div class="productDetailsSection-NoShippingMethod-Title">  No selling company available</div>`
                           : ``
                       }
                         


            </div>
              `;
  return html;
}
function renderProductRowTotalColumnHTML(
  row,
  listOfAllShoppingCartShippingMethodsAndPrices,
  listOfAllShoppingCartSelectedShippingMethods,
  listOfAllShoppingCartTaxAndPaymentTotals
) {
  const hasValidTax = ShoppingCartSharedMethods.skuHasValidTaxOptionForCart(
    row.skuid,
    listOfAllShoppingCartShippingMethodsAndPrices,
    listOfAllShoppingCartSelectedShippingMethods,
    listOfAllShoppingCartTaxAndPaymentTotals
  );
  //  // ❶ If you can’t “Buy Now” or no valid tax option → Contact Seller
  if (!row.canBuyNow || !hasValidTax) {
    return `<button class="shoppingCartRequestQuoteBtn">Contact Seller 1 </button>`;
  }

  // ❷ If no ship-drop options or out of stock → Out of Stock + Contact Seller
  const shipOpts = ShoppingCartSharedMethods.getShippingOptionsAvailableForDropDown(
    row.skuid,
    listOfAllShoppingCartShippingMethodsAndPrices
  );
  if (shipOpts.length < 1 || !row.inStock) {
    return `
        <div id="divRequestQuoteInstead">
          ${!row.InStock ? `<div class="OutOfStock">Out of Stock</div>` : ''}
          <button class="shoppingCartRequestQuoteBtn">Contact Seller 2 </button>
        </div>
      `;
  }

  //  // ❸ Otherwise show the full order summary block
  const subTotal = convertStringAmountToCurrencyAndSignDirectionForLanguage(
    row.subTotal,
    appState.SiteLanguageCookie,
    '$',
    '$',
    '1'
  );
  const savings = convertStringAmountToCurrencyAndSignDirectionForLanguage(
    row.discountTotal,
    appState.SiteLanguageCookie,
    '$',
    '$',
    '1'
  );
  const shipCost = convertStringAmountToCurrencyAndSignDirectionForLanguage(
    ShoppingCartSharedMethods.getTotalShippingCostPerSKUAndStoreIDAsDouble(
      row.skuid,
      row.storeID,
      listOfAllShoppingCartTaxAndPaymentTotals
    ).toString(),
    appState.SiteLanguageCookie,
    '$',
    '$',
    '1'
  );

  const taxTotal = convertStringAmountToCurrencyAndSignDirectionForLanguage(
    ShoppingCartSharedMethods.getTotalTaxCostPerSKUAndStoreIDAsDouble(
      row.skuid,
      row.storeID,
      listOfAllShoppingCartTaxAndPaymentTotals
    ).toString(),
    appState.SiteLanguageCookie,
    '$',
    '$',
    '1'
  );

  const countrySalesTaxTotal = convertStringAmountToCurrencyAndSignDirectionForLanguage(
    ShoppingCartSharedMethods.getTotalCountryTaxCostPerSKUAndStoreIDAsDouble(
      row.skuid,
      row.storeID,
      listOfAllShoppingCartTaxAndPaymentTotals
    ).toString(),
    appState.SiteLanguageCookie,
    '$',
    '$',
    '1'
  );

  const stateSalesTaxTotal = convertStringAmountToCurrencyAndSignDirectionForLanguage(
    ShoppingCartSharedMethods.getTotalStateTaxCostPerSKUAndStoreIDAsDouble(
      row.skuid,
      row.storeID,
      listOfAllShoppingCartTaxAndPaymentTotals
    ).toString(),
    appState.SiteLanguageCookie,
    '$',
    '$',
    '1'
  );

  const citySalesTaxTotal = convertStringAmountToCurrencyAndSignDirectionForLanguage(
    ShoppingCartSharedMethods.getTotalCityTaxCostPerSKUAndStoreIDAsDouble(
      row.skuid,
      row.storeID,
      listOfAllShoppingCartTaxAndPaymentTotals
    ).toString(),
    appState.SiteLanguageCookie,
    '$',
    '$',
    '1'
  );

  //return "teststsing";

  return `
      <div id="divOrderSummaryArea">
        <div class="productDetailsSection-Title-Subtotal">${subTotal}</div>
        <div class="productDetailsSection-Title-Savings">Saving</div>
        <div class="productDetailsSection-AmountSaved">${savings}</div>


         <div class="shoppingCart-sku-ShippingAndTaxWrapper">
                <b>+Shipping</b>
                <br/>
                ${shipCost}
                <br/>
                <div id="divSKUSalesTaxTotal${row.skuid}" data-sku="${row.skuid}" class="jsClassTaxDetailsToogle"  style="cursor:pointer;" >
                <b>+Sales Tax Total</b>
                <img   width="20" height="20"  src="${APP_CONFIG.IMAGES_BASE_URL}imgs/icons/svg/arrow-toggle-up.svg"  class="cartTopNewButton-Image-toggle-icon-rotated"  alt="Toggle tax details" />
                <br/>${taxTotal}

                 </div>


                 <div id="divSKUTaxDetails${row.skuid}"  style="display:none;border:1px solid #ddd;">
                    <b>Country Sales Tax</b>
                    <br/>
                    ${countrySalesTaxTotal}
                    <br/>
                    <b>State Sales Tax</b>
                    <br/>
                    ${stateSalesTaxTotal}
                    <br/>
                    <b>City Sales Tax</b>
                    <br/>
                    ${citySalesTaxTotal}
                    <br/>


                 </div>
          </div>

        </div>
    `;
}

export async function renderCartBottomSummarySection(allShoppingCartData) {
  // pull out your arrays (default to empty arrays so .length is always safe)
  const cartItems = allShoppingCartData?.shoppingCartItems ?? [];
  const listOfAllShoppingCartShippingMethodsAndPrices =
    allShoppingCartData?.allShoppingCartShippingMethodsAndPrices ?? [];
  const listOfAllShoppingCartSelectedShippingMethods =
    allShoppingCartData?.allShoppingCartSelectedShippingMethods ?? [];
  const listOfAllShoppingCartTaxAndPaymentTotals =
    allShoppingCartData?.allShoppingCartTaxAndPaymentTotals ?? [];

  // if no items, render the empty-cart state
  if (cartItems.length === 0) {
    return '';
  }

  // 1) compute all of your totals in one go
  const {
    cartSubTotalAmountX,
    cartSubTotalPlusDiscountAmountX,
    cartTotalShippingX,
    cartTotalDiscountX,
    cartTotalTaxX,
    cartTotalAmountX,
    cartTotalItemsCountX,
  } = ShoppingCartSharedMethods.computeCartTotals(
    cartItems,
    listOfAllShoppingCartShippingMethodsAndPrices,
    listOfAllShoppingCartSelectedShippingMethods,
    listOfAllShoppingCartTaxAndPaymentTotals
  );

  // format back to currency+sign
  const fmt = amt =>
    convertStringAmountToCurrencyAndSignDirectionForLanguage(
      amt.toString(),
      appState.SiteLanguageCookie,
      '$',
      '$',
      '1'
    );

  const cartSubTotalAmount = fmt(cartSubTotalAmountX);
  const cartSubTotalPlusDiscountAmount = fmt(cartSubTotalPlusDiscountAmountX);
  const cartTotalShipping = fmt(cartTotalShippingX);
  const cartTotalDiscount = fmt(cartTotalDiscountX);
  const cartTotalTax = fmt(cartTotalTaxX);
  const cartTotalAmount = fmt(cartTotalAmountX);
  const cartTotalItemsCount = cartTotalItemsCountX.toString();

  // 2) pull out your UI flags
  const overAllCheckOutIsDisabled = allShoppingCartData?.overAllCheckOutIsDisabled ?? false;
  const isVisibleDivCartWithOutOfStockItemMessage =
    allShoppingCartData?.isVisibleDivCartWithOutOfStockItemMessage ?? false;
  const isVisibleDivCartWithNoSellingOptionItemMessage =
    allShoppingCartData?.isVisibleDivCartWithNoSellingOptionItemMessage ?? false;
  const isVisibleDivCartWithCanNotBuyNowItemMessage =
    allShoppingCartData?.isVisibleDivCartWithCanNotBuyNowItemMessage ?? false;

  const html = `<div class="cartRow">
      <div class="BasketIteminfoWrap">
        <div class="productDetailsSection">
          <div class="productDetailsSectionSubTotal">
            subtotal (${cartTotalItemsCount}
              ${cartTotalItemsCount !== '0' ? 'items' : 'item'})
          </div>
        </div>
        <div class="prodSubTotalSummary">
          ${cartSubTotalPlusDiscountAmount}
        </div>
      </div>
    </div>

    <div class="cartRow">
      <div class="BasketIteminfoWrap">
        <div class="productDetailsSection">
          <div class="productDetailsSectionSubTotal">Shipping</div>
        </div>
        <div class="prodSubTotalSummary">
          ${cartTotalShipping}
        </div>
      </div>
    </div>

    <div class="cartRow">
      <div class="BasketIteminfoWrap">
        <div class="productDetailsSection">
          <div class="productDetailsSectionSubTotal">Discounts</div>
        </div>
        <div class="prodSubTotalSummary">
          (${cartTotalDiscount})
        </div>
      </div>
    </div>

    <div class="cartRow">
      <div class="BasketIteminfoWrap">
        <div class="productDetailsSection">
          <div class="productDetailsSectionSubTotal">Tax</div>
        </div>
        <div class="prodSubTotalSummary">
          ${cartTotalTax}
        </div>
      </div>
    </div>

    <div class="cartRow">
      <div class="BasketIteminfoWrap">
        <div class="productDetailsSection">
          <div class="productDetailsSectionSubTotal">Estimated Total</div>
        </div>
        <div class="prodSubTotalSummary">
          ${cartTotalAmount}
        </div>
      </div>
    </div>

    <div class="cartRow">
      <div class="bottomGreenCkeckoutDiv">
        <button
          id="checkoutButton"
          class="bottomGreenCkeckoutBtn"
          ${overAllCheckOutIsDisabled ? 'disabled' : ''}>
          Go to Checkout
        </button>
      </div>
      <div class="divValidationSummary" style="cursor: default;">
        <ul>
          ${
            isVisibleDivCartWithOutOfStockItemMessage
              ? `<li>${lblCartWithOutOfStockItemMessage}</li>`
              : ''
          }
          ${
            isVisibleDivCartWithNoSellingOptionItemMessage
              ? `<li>${lblCartWithNoSellingOptionItemMessage}</li>`
              : ''
          }
          ${
            isVisibleDivCartWithCanNotBuyNowItemMessage
              ? `<li>${lblCartWithCanNotBuyNowItemMessage}</li>`
              : ''
          }
        </ul>
      </div>
    </div>`;

  return html;
}

export async function onFirstLoadOfShoppingCartUpdateSelectedShippingMethodIDWithFirstValidOneIfZeroReloadNotRequired(
  listOfAllCanBuyNowOnlyShoppingCartItems,
  listOfAllShoppingCartShippingMethodsAndPrices,
  listOfAllShoppingCartSelectedShippingMethods
) {
  let resultReloadNotRequired = true;

  if (
    Array.isArray(listOfAllCanBuyNowOnlyShoppingCartItems) &&
    Array.isArray(listOfAllShoppingCartShippingMethodsAndPrices) &&
    Array.isArray(listOfAllShoppingCartSelectedShippingMethods)
  ) {
    for (const row of listOfAllCanBuyNowOnlyShoppingCartItems) {
      // find the selected‐shipping record
      const selRec = listOfAllShoppingCartSelectedShippingMethods.find(
        tt => tt.skuid === row.skuid
      );

      const currentSelectedShippingMethodForSKU = selRec?.selectedShippingMethodID ?? 0;

      // helper to pick the first valid option
      const pickFirstValid = () =>
        listOfAllShoppingCartShippingMethodsAndPrices.find(
          tt => tt.skuid === row.skuid && tt.isValidShippingOptionCart
        );

      if (currentSelectedShippingMethodForSKU > 0) {
        // check if that one is valid
        const valid = listOfAllShoppingCartShippingMethodsAndPrices.find(
          tt =>
            tt.skuid === row.skuid &&
            tt.shippingMethodID === currentSelectedShippingMethodForSKU &&
            tt.isValidShippingOptionCart
        );

        if (!valid) {
          // replace with first valid
          const first = pickFirstValid();
          if (first) {
            row.shippingMethodID = first.shippingMethodID;
            selRec.selectedShippingMethodID = first.shippingMethodID;
            resultReloadNotRequired = false;
          } else {
            console.warn(`No valid shipping options found for SKU ${row.skuid}`);
          }
        }
      } else {
        // none selected yet → pick first valid
        const first = pickFirstValid();
        if (first && selRec) {
          row.shippingMethodID = first.shippingMethodID;
          selRec.selectedShippingMethodID = first.shippingMethodID;
          resultReloadNotRequired = false;
        } else {
          console.warn(`Shipping method not found in selected list for SKU ${row.skuid}`);
        }
      }
    }
  }

  return resultReloadNotRequired;
}

export async function updateAllItemsInCartRowByRowClicked() {
  //let allAffected = "";
  //const cartItems = allShoppingCartData?.shoppingCartItems ?? [];
  //const selectedShippingMethods = allShoppingCartData?.allShoppingCartSelectedShippingMethods ?? [];
  //for (const row of cartItems) {
  //    // 1) Grab the two elements by their IDs
  //    const qtyInput = document.getElementById(`txtQty${row.skuid}`);
  //    const shipSelect = document.getElementById(`dropdownSKUSelectedShippingMethod${row.skuid}`);
  //    let tempRowQty = "0";
  //    let tempRowSelectedShippingMethodID = 0;
  //    // 2) If they exist, read their values
  //    if (qtyInput) {
  //        tempRowQty = qtyInput.value;
  //    }
  //    if (shipSelect) {
  //        tempRowSelectedShippingMethodID = parseInt(shipSelect.value, 10) || 0;
  //    }
  //    // 3) For logging/debugging
  //    if (qtyInput && shipSelect) {
  //        allAffected += ` - sku:${row.skuid} Qty:${tempRowQty} ShippingMethod:${tempRowSelectedShippingMethodID}`;
  //    }
  //    // 4) Enforce MOQ
  //    if (convertStringToInt(tempRowQty) < row.moq) {
  //        tempRowQty = row.moq.toString();
  //        if (qtyInput) qtyInput.value = tempRowQty;
  //    }
  //    // 5) Only update if something changed
  //    const currentQty = row.skuQuantity.toString();
  //    const currentSelectedShipping = ShoppingCartSharedMethods.getSKUCurrentSelectedShippingMethodFromViewState(
  //        row.skuid,
  //        selectedShippingMethods
  //    );
  //    if (
  //        tempRowQty !== currentQty ||
  //        tempRowSelectedShippingMethodID !== currentSelectedShipping
  //    ) {
  //        // call your backend to update this one row
  //        await fetchUpdateCartItemWithQty(
  //            tempRowQty,
  //            row.skuid,
  //            row.departmentID,
  //            row.categoryID,
  //            row.productID,
  //            tempRowSelectedShippingMethodID
  //        );
  //    }
  //}
  //// 6) After all rows pushed, refresh your app state & UI
  //await updateShoppingCartEventTriggered();
  //await populateCartData();
  //// 7) Optionally show status
  //const statusEl = document.getElementById("lblStatus");
  //if (statusEl) statusEl.textContent = `Refresh All Rows Ran --${allAffected}`;
}

export async function attachMainEventListenersForThisComponent() {
  try {
    console.log('✅ buildComponentCheckoutShoppingCart event listeners attached.');

    await setupContinueShoppingButtonListeners();

    await setupTaxDetailsToggleListeners();

    await setupRemoveSKUFromCartPreDeleteListeners();

    await setupRemoveSKUFromCartCancelRemoveListeners();

    await setupRemoveSKUFromCartSaveForLaterListeners();
  } catch (error) {
    console.error(
      '❌ Error attaching event listeners to buildComponentCheckoutShoppingCart:',
      error
    );
  }
}

async function setupContinueShoppingButtonListeners() {
  const continueShoppingBtn = document.getElementById('btnContinueShopping');
  if (!continueShoppingBtn) return;

  const onContinueShoppingClick = async () => {
    await handleContinueShopping();
  };

  continueShoppingBtn.removeEventListener('click', onContinueShoppingClick);
  continueShoppingBtn.addEventListener('click', onContinueShoppingClick);
}

//async function setupContinueShoppingButtonListeners() {

//    const continueShoppingBtn = document.getElementById("btnContinueShopping");
//    if (continueShoppingBtn) {
//        const clone = continueShoppingBtn.cloneNode(true);
//        continueShoppingBtn.parentNode.replaceChild(clone, continueShoppingBtn);
//        addListenerViaCurrentlyAttachedListenersRegistry(clone, "click", async () => {
//            await handleContinueShopping();
//        });
//    }

//}

async function handleContinueShopping() {
  // alert("Continue shopping button clicked!");

  let returnUrl = appState.MyUserLastPageVisitedListing;

  if (returnUrl === '') {
    returnUrl = '/';
  }

  navigateTo(returnUrl);
}

async function setupTaxDetailsToggleListeners() {
  const allShoppingCartRowTaxDetailsToogleBtns = Array.from(
    document.getElementsByClassName('jsClassTaxDetailsToogle')
  );

  if (allShoppingCartRowTaxDetailsToogleBtns.length > 0) {
    allShoppingCartRowTaxDetailsToogleBtns.forEach(btn => {
      const onToggleTaxDetailsClick = async () => {
        await handleToggleTaxDetails(btn);
      };

      btn.removeEventListener('click', onToggleTaxDetailsClick);
      btn.addEventListener('click', onToggleTaxDetailsClick);
    });
  }
}

//async function setupTaxDetailsToggleListeners() {

//    const allShoppingCartRowTaxDetailsToogleBtns = Array.from(document.getElementsByClassName("jsClassTaxDetailsToogle"));

//    if (allShoppingCartRowTaxDetailsToogleBtns) {
//        allShoppingCartRowTaxDetailsToogleBtns.forEach((btn, i) => {
//            const clone = btn.cloneNode(true);
//            btn.parentNode.replaceChild(clone, btn);
//            addListenerViaCurrentlyAttachedListenersRegistry(clone, "click", async () => {
//                await handleToggleTaxDetails(clone);
//            });
//        });

//    }

//}

async function handleToggleTaxDetails(btn) {
  // alert("Tax details button clicked!");

  const skuID = btn.getAttribute('data-sku');

  // alert(`SKU ID: ${skuID}`);

  const skuTaxDetailsDiv = document.getElementById(`divSKUTaxDetails${skuID}`);

  const img = btn.querySelector('img');

  if (skuTaxDetailsDiv) {
    // alert("Tax details div found!");

    const isVisible = skuTaxDetailsDiv.style.display === 'block';
    skuTaxDetailsDiv.style.display = isVisible ? 'none' : 'block';

    img.classList.toggle('cartTopNewButton-Image-toggle-icon-rotated', isVisible);
  }
}

async function setupRemoveSKUFromCartPreDeleteListeners() {
  const allShoppingCartRowRemoveBtns = Array.from(
    document.getElementsByClassName('shoppingCartDeleteBtn')
  );

  if (allShoppingCartRowRemoveBtns.length > 0) {
    allShoppingCartRowRemoveBtns.forEach(btn => {
      const onRemoveBtnClick = async () => {
        await handleRemoveSKUFromCartPreDelete(btn);
      };

      btn.removeEventListener('click', onRemoveBtnClick);
      btn.addEventListener('click', onRemoveBtnClick);
    });
  }
}

//async function setupRemoveSKUFromCartPreDeleteListeners() {
//    const allShoppingCartRowRemoveBtns = Array.from(document.getElementsByClassName("shoppingCartDeleteBtn"));
//    if (allShoppingCartRowRemoveBtns) {
//        allShoppingCartRowRemoveBtns.forEach((btn, i) => {
//            const clone = btn.cloneNode(true);
//            btn.parentNode.replaceChild(clone, btn);
//            addListenerViaCurrentlyAttachedListenersRegistry(clone, "click", async () => {
//                await handleRemoveSKUFromCartPreDelete(clone);
//            });
//        });
//    }
//}

async function handleRemoveSKUFromCartPreDelete(btn) {
  // alert("Remove SKU from cart button clicked!");
  const skuID = btn.getAttribute('data-sku');
  // alert(`SKU ID: ${skuID}`);

  const skuRemoveParentDiv = document.getElementById(`divRemoveSKUFromCartParent${skuID}`);
  const skuRemoveChildDiv = document.getElementById(`divRemoveSKUFromCartChild${skuID}`);

  if (skuRemoveParentDiv && skuRemoveChildDiv) {
    skuRemoveParentDiv.style.display = 'none';
    skuRemoveChildDiv.style.display = 'block';
  }
}

async function setupRemoveSKUFromCartCancelRemoveListeners() {
  const allShoppingCartRowRemoveCancelBtns = Array.from(
    document.getElementsByClassName('shoppingCartDeleteBtn-Cancel')
  );

  if (allShoppingCartRowRemoveCancelBtns.length > 0) {
    allShoppingCartRowRemoveCancelBtns.forEach(btn => {
      const onCancelRemoveBtnClick = async () => {
        await handleRemoveSKUFromCartCancelRemove(btn);
      };

      btn.removeEventListener('click', onCancelRemoveBtnClick);
      btn.addEventListener('click', onCancelRemoveBtnClick);
    });
  }
}

//async function setupRemoveSKUFromCartCancelRemoveListeners() {
//    const allShoppingCartRowRemoveCancelBtns = Array.from(document.getElementsByClassName("shoppingCartDeleteBtn-Cancel"));
//    if (allShoppingCartRowRemoveCancelBtns) {
//        allShoppingCartRowRemoveCancelBtns.forEach((btn, i) => {
//            const clone = btn.cloneNode(true);
//            btn.parentNode.replaceChild(clone, btn);
//            addListenerViaCurrentlyAttachedListenersRegistry(clone, "click", async () => {
//                await handleRemoveSKUFromCartCancelRemove(clone);
//            });
//        });
//    }
//}

async function handleRemoveSKUFromCartCancelRemove(btn) {
  // alert("Remove SKU from cart button clicked!");
  const skuID = btn.getAttribute('data-sku');
  // alert(`SKU ID: ${skuID}`);
  const skuRemoveParentDiv = document.getElementById(`divRemoveSKUFromCartParent${skuID}`);
  const skuRemoveChildDiv = document.getElementById(`divRemoveSKUFromCartChild${skuID}`);
  if (skuRemoveParentDiv && skuRemoveChildDiv) {
    skuRemoveParentDiv.style.display = 'block';
    skuRemoveChildDiv.style.display = 'none';
  }
}

async function setupRemoveSKUFromCartSaveForLaterListeners() {
  const allShoppingCartRowRemoveSaveForLaterBtns = Array.from(
    document.getElementsByClassName('shoppingCart-DeleteSaveForLaterBtn')
  );

  if (allShoppingCartRowRemoveSaveForLaterBtns.length > 0) {
    allShoppingCartRowRemoveSaveForLaterBtns.forEach(btn => {
      const onSaveForLaterBtnClick = async () => {
        await handleRemoveSKUFromCartSaveForLater(btn);
      };

      btn.removeEventListener('click', onSaveForLaterBtnClick);
      btn.addEventListener('click', onSaveForLaterBtnClick);
    });
  }
}

//async function setupRemoveSKUFromCartSaveForLaterListeners() {
//    const allShoppingCartRowRemoveSaveForLaterBtns = Array.from(document.getElementsByClassName("shoppingCart-DeleteSaveForLaterBtn"));
//    if (allShoppingCartRowRemoveSaveForLaterBtns) {
//        allShoppingCartRowRemoveSaveForLaterBtns.forEach((btn, i) => {
//            const clone = btn.cloneNode(true);
//            btn.parentNode.replaceChild(clone, btn);
//            addListenerViaCurrentlyAttachedListenersRegistry(clone, "click", async () => {
//                await handleRemoveSKUFromCartSaveForLater(clone);
//            });
//        });
//    }
//}

async function handleRemoveSKUFromCartSaveForLater(btn) {
  alert('Remove SKU from cart save for later clicked!');
}
